const words = [
  "Payments",
  "✦",
  "Wallets",
  "✦",
  "AI Evaluation",
  "✦",
  "Merchant Rails",
  "✦",
  "0 → 1",
  "✦",
  "Growth",
  "✦",
  "Product Strategy",
  "✦",
  "Trust & Safety",
  "✦",
];

const Marquee = () => {
  const line = words.concat(words);
  return (
    <section
      className="relative border-y border-[var(--bone)]/10 bg-[var(--ink-2)]/40 overflow-hidden py-8 md:py-10"
      data-testid="marquee"
      aria-label="marquee"
    >
      <div className="marquee-track flex whitespace-nowrap gap-14">
        {line.concat(line).map((w, i) => (
          <span
            key={i}
            className={`font-serif italic text-[7vw] md:text-[5.5vw] leading-none ${
              w === "✦" ? "text-[var(--copper)] not-italic font-sans" : "text-[var(--bone)]"
            }`}
          >
            {w}
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
